// extracted by mini-css-extract-plugin
export default {"content":"Product_dev2_content__IdPUM","ref":"Product_dev2_ref__EX-Q7"};